import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0C3.13895 0 0 3.13895 0 7C0 10.8611 3.13895 14 7 14C10.8611 14 14 10.8611 14 7C14 3.13895 10.8611 0 7 0ZM1.54737 7C1.54737 5.77684 1.96 4.64205 2.63792 3.72842L10.2716 11.3621C9.35795 12.0547 8.22318 12.4527 7.00003 12.4527C3.99371 12.4527 1.54739 10.0063 1.54739 7.00003L1.54737 7ZM11.3621 10.2716L3.72842 2.63789C4.64208 1.94537 5.77684 1.54742 7 1.54742C10.0063 1.54742 12.4526 3.99376 12.4526 7.00005C12.4526 8.22321 12.0547 9.358 11.3622 10.2716L11.3621 10.2716Z"
      fill="#FA3C30"
    />
  </svg>
);
export default SVGComponent;
